import { AddressDetailsPayload } from '@/models/location.model'
import { PublicService } from '@/models/public/bookingWidget.model'
import { OrderItem } from '@/models/public/order.model'
import { RelatedServiceLocation } from '@/models/public/service.model'

export interface RoutePayload {
  route: number
  start_time: string | null
  start_point: AddressDetailsPayload
  end_point: AddressDetailsPayload
}

export interface RouteStopPayload {
  route: number
  service: number
  start_time: Date | null
  end_time: Date | null
}

export interface UpdateRouteStopPayload {
  id: number
  start_time: string | null
  end_time: string | null
  order_index: number
}

export interface Route {
  id: number
  hash_id: string
  name: string
  start_time: Date | null
  start_point: RelatedServiceLocation | null
  end_point: RelatedServiceLocation | null
  stops: RouteStop[]
  segments: DrivingSegment[]
}

export interface ServerRoute extends Omit<Route, 'start_time' | 'stops'> {
  start_time: string | null
  stops: ServerRouteStop[]
}

export interface RouteStop {
  id: number
  route: number
  service: PublicService
  order_item: OrderItem | null
  start_time: Date | null
  end_time: Date | null
  order_index: number
}

export interface ServerRouteStop
  extends Omit<RouteStop, 'start_time' | 'end_time'> {
  start_time: string | null
  end_time: string | null
}

export interface DrivingSegment {
  id: number
  route_id: number
  from_stop: RouteStop | null
  to_stop: RouteStop | null
  from_location: RelatedServiceLocation
  to_location: RelatedServiceLocation
  duration_minutes: number
  distance_km: number
}

export interface DrivingSegmentPayload {
  route: number
  from_stop: number | null
  to_stop: number | null
  from_location: number | null
  to_location: number | null
  duration_minutes: number
  distance_km: number
}

export enum JourneyDuration {
  NONE = '',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}
